import { render, staticRenderFns } from "./HelpIndex.vue?vue&type=template&id=6e1d67f7&scoped=true"
import script from "./HelpIndex.vue?vue&type=script&lang=js"
export * from "./HelpIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1d67f7",
  null
  
)

export default component.exports